export const FEED_CARD_SKELETON_TEST_ID = "feed-card-skeleton";
